import React from 'react';
import './privacy-policy.css';
import Navbar from '../Menus/Navbar';
import Footer from '../Menus/Footer';

export default function PrivacyPolicy() {
  return (
    <>
      <Navbar />
      <section id="privacy-policy-section">
        <div className="privacy-container">
          <h1 id="policy-title">Privacy Policy</h1>
          <p id="policy-intro">
            At <strong>Home Appliance Assist</strong>, we are committed to protecting the privacy and security of our customers' personal information. This Privacy Policy outlines the types of information we collect, how we use it, and the steps we take to ensure your information remains secure.
          </p>

          <div className="policy-point" id="info-we-collect">
            <h3>1. Information We Collect</h3>
            <ul>
              <li>Name</li>
              <li>Address</li>
              <li>Phone Number</li>
              <li>IP Address</li>
            </ul>
          </div>

          <div className="policy-point" id="purpose-info">
            <h3>2. Purpose of Collecting Information</h3>
            <p>
              The personal information we collect is used exclusively for the following purposes:
            </p>
            <ul>
              <li>To follow up with customers regarding their service requests.</li>
              <li>To inform customers about their upcoming service appointments.</li>
              <li>To provide personalized customer support and assistance.</li>
              <li>To enhance website security and prevent fraud through IP monitoring.</li>
            </ul>
          </div>

          <div className="policy-point" id="storage-info">
            <h3>3. Storage of Information</h3>
            <p>All collected personal information is securely maintained in a Google Sheet, which is accessible only to authorized personnel.</p>
          </div>

          <div className="policy-point" id="protection-info">
            <h3>4. Protection of Information</h3>
            <p>We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.</p>
          </div>

          <div className="policy-point" id="sharing-info">
            <h3>5. Sharing of Information</h3>
            <p>We do not share, sell, or disclose your personal information to any third parties. Your trust is important to us, and we ensure your information is handled with the utmost care and confidentiality.</p>
          </div>

          <div className="policy-point" id="transparency">
            <h3>6. Transparency and Accountability</h3>
            <p>We are a trusted service community and value transparency. Our commitment to protecting your privacy is a fundamental part of our service.</p>
          </div>

          <div className="policy-point" id="consent">
            <h3>7. Customer Consent</h3>
            <p>By providing your personal information, you consent to its use in accordance with this Privacy Policy. We will not use your information for any other purpose without your explicit consent.</p>
          </div>

          <div className="policy-point" id="updates">
            <h3>8. Updates to Privacy Policy</h3>
            <p>We may update this Privacy Policy from time to time. Changes will be posted on our website (<a href="https://www.homeapplianceassist.in" target="_blank" rel="noopener noreferrer">homeapplianceassist.in</a>) and will take effect immediately upon posting.</p>
          </div>

          <div className="policy-point" id="your-rights">
            <h3>9. Your Rights</h3>
            <p>You have the right to access, update, or request the deletion of your personal information at any time. Please contact us if you wish to exercise these rights.</p>
          </div>

          <div className="policy-point" id="contact-us">
            <h3>10. Contact Us</h3>
            <p>If you have any questions or concerns about our Privacy Policy or the handling of your personal information, please contact us at <strong>Home Appliance Assist</strong>.</p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
